@if (store.recentSearches().length) {
  <section
    class="suggestions__section"
    [attr.aria-labelledby]="uid + '-recent'">
    <header class="suggestions__header">
      <h2
        class="suggestions__title"
        [id]="uid + '-recent'">
        {{ 'search-bar.recent' | i18next }}
      </h2>
      @if (canExpandRecent()) {
        <button
          type="button"
          class="suggestions__more"
          [attr.aria-expanded]="showAllRecent()"
          (click)="showAllRecent.set(!showAllRecent())">
          @if (showAllRecent()) {
            {{ 'search-bar.show-less' | i18next }}
          } @else {
            {{ 'search-bar.show-more' | i18next }}
          }
        </button>
      }
    </header>
    <ul class="suggestions__recent">
      @for (search of visibleRecent(); track search.id) {
        <li>
          <a
            class="suggestions__recent-link"
            [href]="search.searchUrl"
            (click)="store.openRecentSearch($event, search)"
            >{{ search.searchString }}</a
          >
        </li>
      }
    </ul>
  </section>
}

@if (store.categories().length) {
  <section
    class="suggestions__section"
    [attr.aria-labelledby]="uid + '-interests'">
    <h2
      class="suggestions__title"
      [id]="uid + '-interests'">
      {{ 'search-bar.interests' | i18next }}
    </h2>
    <ul class="suggestions__row">
      @for (category of store.categories(); track category.id; let i = $index) {
        <li>
          <a
            class="suggestions__interest"
            [routerLink]="category.link"
            [state]="{ refresh: true }"
            [replaceUrl]="store.hasHistoryEntry()"
            (click)="store.onNavigate(category)">
            <img
              class="suggestions__interest-icon"
              alt=""
              width="48"
              height="48"
              decoding="async"
              [attr.loading]="i < eagerImages ? 'eager' : 'lazy'"
              [src]="category.icon" />
            <span>{{ category.label }}</span>
          </a>
        </li>
      }
    </ul>
  </section>
}

@if (store.regions().length) {
  <section
    class="suggestions__section"
    [attr.aria-labelledby]="uid + '-regions'">
    <h2
      class="suggestions__title"
      [id]="uid + '-regions'">
      {{ 'search-bar.regions' | i18next }}
    </h2>
    <ul class="suggestions__row">
      @for (region of store.regions(); track region.key; let i = $index) {
        <li>
          <a
            class="suggestions__region"
            [routerLink]="region.link"
            [replaceUrl]="store.hasHistoryEntry()"
            (click)="store.onNavigate(region)">
            <img
              class="suggestions__region-map"
              alt=""
              width="72"
              height="86"
              decoding="async"
              [attr.loading]="i < eagerImages ? 'eager' : 'lazy'"
              [src]="region.image" />
            <span>{{ region.label }}</span>
          </a>
        </li>
      }
    </ul>
  </section>
}
